module.exports = __webpack_public_path__ + "img/shop_off.68c4b91f.svg";